import { FC, ReactElement, useContext, useEffect, useState } from 'react';
import { getPresentationComponent } from '../common/Common';
import { AppContext } from '../contexts/AppContext';
import ArticleView from './Article';
import DeviceHandle from './Device';
import SplashScreen from './SplashScreen';
import { ARTICLE_SCHEMA_ID, COLOR_PREVIEW_ID, COLOR_SCHEMA_ID, DEVICE_SCHEMA_ID, PRESENTATION_SCHEMA_ID } from '../Settings';

/**
 * Render a preview based on incoming postMessage data
 * @returns {JSX.Element} Component template
 */
const PreviewView: FC = () => {
  const { setCurrentLanguage, setPreviewIsActive, setPreviewSchemaId, setForceUpdate } = useContext(AppContext);
  const [previewData, setPreviewData] = useState<any>(null);
  const [formData, setFormData] = useState<any>({});
  const [schemaId, setSchemaId] = useState<number>();
  const [previewElement, setPreviewElement] = useState<ReactElement>();

  // Update previewdata state when postmessage is sensed
  useEffect(() => {
    window.addEventListener("message", message => {
      setPreviewIsActive(true);

      try {
        setPreviewData(JSON.parse(message?.data));
      } catch (e) {}
    }, false);
  }, [setPreviewIsActive]);

  // Extract language, formData and schema name on each update
  useEffect(() => {
    // Get language
    setCurrentLanguage(previewData?.locale || "no");

    // Get formdata
    setFormData(previewData?.formData);

    // If forceUpdate is set, update
    setForceUpdate(previewData?.formData?.forceUpdate ?? null);

    // Get schema name
    setSchemaId(previewData?.schemas?.schema_id);
    setPreviewSchemaId(previewData?.schemas?.schema_id);
  }, [previewData, setCurrentLanguage, setPreviewSchemaId, setForceUpdate]);  

  // Get the correct view based on document type and presentation type
  useEffect(() => {
    switch(schemaId) {
      case ARTICLE_SCHEMA_ID:
        setPreviewElement(<ArticleView previewData={formData}/>);
        break;
      case PRESENTATION_SCHEMA_ID:
        setPreviewElement(getPresentationComponent(formData?.general?.presentationType, formData));
        break;
      case DEVICE_SCHEMA_ID:
        setPreviewElement(<DeviceHandle previewData={formData}/>);
        break;
      case COLOR_SCHEMA_ID:
        setPreviewElement(<DeviceHandle previewData={{"general": {"showTitle": true,"startScreen": "first","internalTitle": "","title": {"no": "Lorem ipsum", "sv": "Lorem ipsum", "en": "Lorem ipsum"}},"idleMode": {"idleTime": "disabled"},"languages": ["no","sv","en"],"accessibility": {"showHomeIcon": true,"showVolumeIcon": true,"toggleFontSize": true,"showScrollToTop":true}, "colors": formData?.colors, "presentations": {"list": [{"to_document_id": COLOR_PREVIEW_ID}]}}}/>);
        break;
      default:
        setPreviewElement(<SplashScreen/>);
        break;
    }
  }, [schemaId, formData]);

  return <>{previewElement}</>;
}

export default PreviewView;
